var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('PlatformPreview',{attrs:{"platform":_vm.platform}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }